if (!customElements.get('vx-pdp-image-actions')) {
  customElements.define('vx-pdp-image-actions', class extends HTMLElement {
    connectedCallback() {
      this.viewer = this.parentElement.querySelector('.product__media-gallery-viewer');
      this.mediaList = this.viewer?.querySelector('.product__media-list');
      if (!this.viewer || !this.mediaList) return;

      this.mobile = window.matchMedia('(max-width: 767.98px)');
      this.scheduleUpdate = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.updatePosition();
        });
      };
      this.resizeObserver = new ResizeObserver(this.scheduleUpdate);
      this.resizeObserver.observe(this.viewer);
      this.mutationObserver = new MutationObserver(this.scheduleUpdate);
      this.mutationObserver.observe(this.mediaList, { childList: true });
      this.mobile.addEventListener('change', this.scheduleUpdate);

      const view360 = this.querySelector('.glasson-btn-360');
      if (view360) view360.setAttribute('aria-label', 'Brille in 360 Grad ansehen');
      this.scheduleUpdate();
    }

    updatePosition() {
      if (!this.isConnected) return;
      const firstMedia = this.mediaList.querySelector('.product__media-item');
      if (firstMedia !== this.firstMedia) {
        if (this.firstMedia) this.resizeObserver.unobserve(this.firstMedia);
        this.firstMedia = firstMedia;
        if (firstMedia) this.resizeObserver.observe(firstMedia);
      }

      // The desktop grid is tall; anchor only to its hero, not its last image.
      const anchor = this.mobile.matches ? this.viewer : firstMedia;
      if (!anchor) return;
      const height = Math.round(anchor.getBoundingClientRect().bottom - this.parentElement.getBoundingClientRect().top);
      if (height <= 0) {
        this.removeAttribute('data-positioned');
        return;
      }
      const value = `${height}px`;
      if (this.style.getPropertyValue('--vx-pdp-hero-height') !== value) {
        this.style.setProperty('--vx-pdp-hero-height', value);
      }
      this.setAttribute('data-positioned', '');
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.mutationObserver?.disconnect();
      this.mobile?.removeEventListener('change', this.scheduleUpdate);
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = null;
      this.firstMedia = null;
    }
  });
}
